/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface CardWithUserReissueOneOf
 */
export interface CardWithUserReissueOneOf {
    /**
     * 
     * @type {string}
     * @memberof CardWithUserReissueOneOf
     */
    'cardType': CardWithUserReissueOneOfCardTypeEnum;
    /**
     * Expiration date of the previous virtual card that was replaced by automatic reissuance.
     * @type {string}
     * @memberof CardWithUserReissueOneOf
     */
    'expiredDate': string;
}

export const CardWithUserReissueOneOfCardTypeEnum = {
    virtual: 'virtual'
} as const;

export type CardWithUserReissueOneOfCardTypeEnum = typeof CardWithUserReissueOneOfCardTypeEnum[keyof typeof CardWithUserReissueOneOfCardTypeEnum];


